import { connect } from 'react-redux'
import compose from 'recompose/compose'
import { withI18next } from 'lib/i18n/withI18next'
import PropTypes from 'prop-types'
import React, { useEffect, useRef, useState } from 'react'
import ReviewApiHandler from 'lib/api/review'
import ReviewImagesModal from 'components/pdp/shared-components/review-images-modal/ReviewImagesModal'
import Typo from 'constants/typography'
import { hasLocizeTranslation } from 'lib/utils/locize'
import clsx from 'clsx'
import { EVENT } from 'lib/segment/const'
import StateStorage from 'lib/state-storage'
import useIntersection from 'components/custom-hooks/useIntersection'
import styles from './product-style-gallery.scss'
import ProductStyleGalleryImages from './product-style-gallery-images/ProductStyleGalleryImages'

const ProductStyleGallery = ({ t, isPhone, productId }) => {
  const [productReviewImages, setProductReviewImages] = useState([])
  const token = StateStorage.getAuthToken()
  const anchorRef = useRef()
  const isVisible = useIntersection(anchorRef, { rootMargin: '200px' })

  // effects
  useEffect(() => {
    const fetchProductReviewsList = async () => {
      try {
        const result = await ReviewApiHandler.getProductReviewImages({
          id_product: productId,
        })
        if (result) {
          const productReviewImagesResult = result?.product_review_images || []
          setProductReviewImages(productReviewImagesResult)
        }
      } catch (error) {
        // eslint-disable-next-line
        console.error(error)
      }
    }
    if (token && isVisible) {
      fetchProductReviewsList()
    }
  }, [productId, token, isVisible])

  if (productReviewImages.length === 0) {
    return <div ref={anchorRef} />
  }

  return (
    <div
      data-cy="product-style-gallery-container"
      className="product-style-gallery-container"
    >
      <style jsx>{styles}</style>
      <div
        className={clsx(
          isPhone ? Typo.subtitle1 : Typo.title3,
          'product-style-gallery-container__title',
        )}
      >
        {hasLocizeTranslation(t, 'STYLE_GALLERY', 'Style Gallery')}
      </div>
      <div className="product-style-gallery-container__imgs_wrapper">
        {productReviewImages.map((reviewImage, idx) => {
          const image = reviewImage?.images?.[0]
          const imageUrl = image?.image_url

          return (
            <div key={reviewImage?.id_order}>
              <ReviewImagesModal
                id_product_review_image={image?.id_product_review_image}
                triggerImageClassName="product-style-gallery-container__img"
                id_product={productId}
                segmentEvent={EVENT.styleGalleryViewImageClicked}
                imageUrl={imageUrl}
              >
                <ProductStyleGalleryImages
                  viewIndex={idx}
                  productReviewImages={productReviewImages}
                />
              </ReviewImagesModal>
            </div>
          )
        })}
      </div>
    </div>
  )
}

ProductStyleGallery.propTypes = {
  // component props
  productId: PropTypes.number.isRequired,

  // redux props
  t: PropTypes.func.isRequired,
  isPhone: PropTypes.bool.isRequired,
  internationalization: PropTypes.shape({
    country: PropTypes.string,
    language: PropTypes.string,
  }).isRequired,
}

export default compose(
  connect((state) => ({
    isPhone: state.device.isPhone,
    internationalization: state.internationalization,
  })),
  withI18next(),
)(ProductStyleGallery)
